import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentTableList = styled.div`
  grid-column: 1/4;
  margin: 0 4.5em;
  .MuiPaper-elevation2 {
    box-shadow: none;
    margin: 1em 0;
  }
  .MuiToolbar-regular {
    min-height: 0px;
  }
`;

export const ContentLoader = styled.div`
  grid-column: 1/4;
  display: flex;
  text-align: center;
  height: 69vh;
  align-items: center;
`;

export const ContentPagination = styled.div`
  p {
    margin-top: inherit;
    margin-bottom: inherit;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 0;
  p {
    margin-top: 24px;
    font-size: 18px;
    color: ${({ theme }) => theme.neutral.gray[2600]};
  }
`;

export const useStyles = makeStyles(() => ({
  delete: {
    color: theme.status.error,
  },
}));
